export default class TemplateUtils {
  public static capitalizeFirstLetter(text: string | null): string | null {
    if (!text) return null;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
